import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var ArrowRightIcon = function () { return (jsxs("svg", __assign({ width: "8", height: "16", viewBox: "0 0 8 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "Arrow right" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.58443 8.00041L1.3855 3.43051L2.61435 2.57031L6.41541 8.00041L2.61435 13.4305L1.3855 12.5703L4.58443 8.00041Z", fill: "currentColor" })] }))); };

export { ArrowRightIcon };
